import { METRICS } from '../constants';
import { toFixedNumber } from '../../utils/number';

const loadNavigationTimingMonitor = (aggregator) => {
  const [navigationTiming] = window.performance.getEntriesByType('navigation');

  if (navigationTiming) {
    const {
      domComplete,
      domContentLoadedEventEnd,
      domContentLoadedEventStart,
      domInteractive,
      loadEventEnd,
      loadEventStart,
      redirectCount,
      requestStart,
      responseStart,
      responseEnd,
      type: navigationType,
    } = navigationTiming;

    if (redirectCount) {
      aggregator(METRICS.REDIRECT_COUNT, redirectCount);
    }

    if (domComplete) {
      aggregator(METRICS.DOM_COMPLETE, toFixedNumber(domComplete));
    }

    if (domInteractive) {
      aggregator(METRICS.DOM_INTERACTIVE, toFixedNumber(domInteractive));
    }

    if (domContentLoadedEventEnd) {
      aggregator(
        METRICS.DOM_CONTENT_LOADED_END,
        toFixedNumber(domContentLoadedEventEnd),
      );
    }

    if (domContentLoadedEventStart) {
      aggregator(
        METRICS.DOM_CONTENT_LOADED_START,
        toFixedNumber(domContentLoadedEventStart),
      );
    }

    if (domContentLoadedEventStart && domContentLoadedEventEnd) {
      aggregator(
        METRICS.DOM_CONTENT_LOADED,
        toFixedNumber(domContentLoadedEventEnd - domContentLoadedEventStart),
      );
    }

    if (loadEventEnd) {
      aggregator(METRICS.ONLOAD_END, toFixedNumber(loadEventEnd));
    }

    if (loadEventStart) {
      aggregator(METRICS.ONLOAD_START, toFixedNumber(loadEventStart));
    }

    if (loadEventStart && loadEventEnd) {
      aggregator(METRICS.ONLOAD, toFixedNumber(loadEventEnd - loadEventStart));
    }

    if (requestStart) {
      aggregator(METRICS.REQUEST_START, toFixedNumber(requestStart));
    }

    if (responseStart) {
      aggregator(METRICS.RESPONSE_START, toFixedNumber(responseStart));
    }

    if (responseEnd) {
      aggregator(METRICS.RESPONSE_END, toFixedNumber(responseEnd));
    }

    if (responseStart && responseEnd) {
      aggregator(
        METRICS.RESPONSE_TIME,
        toFixedNumber(responseEnd - responseStart),
      );
    }

    if (navigationType) {
      aggregator(METRICS.NAVIGATION_TYPE, navigationType);
    }
  }
};

export { loadNavigationTimingMonitor };
